import findLastIndex from 'lodash/findLastIndex';
import take from 'lodash/fp/take';
import isNil from 'lodash/isNil';
import last from 'lodash/last';

import { FlatDrawer } from '..';
import type { ReactiveVars } from '../../../..';

export default function createOpenChildDrawer(drawersVar: ReactiveVars['drawersVar']) {
  return <T extends FlatDrawer>(newDrawer: T): void => {
    const drawers = drawersVar();
    const lastDrawer = last(drawers);

    if (isNil(lastDrawer)) {
      throw Error('Tried to open a child drawer without a parent');
    } else if (lastDrawer.visible) {
      drawersVar(drawers.concat([newDrawer]));
    } else {
      const indexOflastVisible = findLastIndex(drawers, { visible: true });
      const newDrawers = take(indexOflastVisible + 1, drawers);

      if (indexOflastVisible === -1) {
        throw Error('Tried to open a child drawer without a visible parent');
      } else {
        drawersVar(newDrawers.concat([newDrawer]));
      }
    }
  };
}
